module.exports = __webpack_public_path__ + "img/alumini-program/01.jpg";